// Import timeline component
import '../components/timeline.js';

var masterTimelinesForCarouselWithVerticalLinks = [];

// Consider creating an instance for each carousel
var animating = false;

function setAnimating(state) {
 animating = state;
}

function startAnimating() {
  setAnimating(true);
}

function stopAnimating() {
  setAnimating(false);
}

function slideOutCarouselImage(element) {  
  var tlSlideOut = new TimelineMax();
  
  tlSlideOut
    .to(element.find('.slide-inner'), 2, { y: '-50', autoAlpha: 0 });

  return tlSlideOut;
}

function slideInCarouselImage(element) {
  var tlSlideIn = new TimelineMax();
  
  tlSlideIn
    .fromTo(element.find('.slide-inner'), 2, { y: '50', autoAlpha: 0 }, { visibility: 'visible', y: '0', autoAlpha: 1, onComplete: stopAnimating })
    .to(element.siblings(), 0, {visibility: 'hidden'});

  return tlSlideIn;  
}

function slideOutCarouselMixedContent(element) {  
  var tlSlideOut = new TimelineMax();
  
  tlSlideOut
    .to(element.find('.heading'), 1, { y: '-50', autoAlpha: 0 })
    .to(element.find('.paragraph'), 1, { y: '-50', autoAlpha: 0 }, '-=0.75')
    .to(element.find('.image'), 1, { y: '-50', autoAlpha: 0 }, '-=0.75')
    .to(element.find('.slide-inner'), 0, { autoAlpha: 0 });

  return tlSlideOut;
}

function slideInCarouselMixedContent(element) {
  var tlSlideIn = new TimelineMax();
  
  tlSlideIn
    .to(element, 0, { visibility: 'visible' })
    .fromTo(element.find('.slide-inner'), 1, { y: '50', autoAlpha: 0 }, { y: '0', autoAlpha: 1 })
    .fromTo(element.find('.heading'), 1, { y: '50', autoAlpha: 0 }, { y: '0', autoAlpha: 1 })
    .fromTo(element.find('.paragraph'), 1, { y: '50', autoAlpha: 0 }, { y: '0', autoAlpha: 1 }, '-=0.75')
    .fromTo(element.find('.image'), 1, { y: '50', autoAlpha: 0 }, { y: '0', autoAlpha: 1, onComplete: stopAnimating}, '-=0.75')
    .to(element.siblings(), 0, {visibility: 'hidden'});

  return tlSlideIn;  
}

function initiateCarouselsWithVerticalLinks() {

  jQuery('.carousel--vertical-links-image').each(function(key) {
    var componentIdName = 'carousel--with-vertical-links-image-' + key;
    var sliderIdName = 'slides--vertical-links-image-' + key;
    var sliderNavIdName = 'navigation--vertical-links-image-' + key;

    this.id = componentIdName;

    jQuery('#' + componentIdName + ' .links .link:first-child').addClass('active');
    jQuery('#' + componentIdName + ' .slides .slide:first-child').addClass('active');

    jQuery('.slides--vertical-links-image')[key].id = sliderIdName;
    jQuery('.navigation--vertical-links-image')[key].id = sliderNavIdName;

    masterTimelinesForCarouselWithVerticalLinks[key] = new TimelineMax();

    jQuery('#' + componentIdName + ' .links .link').each(function(key) {
      jQuery(this).data('slide-target', '#' + componentIdName + ' #slide-' + key);
    });

    jQuery('#' + componentIdName + ' .links .link').click(function() {
      if (!jQuery(this).hasClass('.active')) {
        if (animating == false) {        
          
          startAnimating();

          // Remember which is the originally active slide
          let activeSlide = jQuery('#' + componentIdName + ' .slide.active');     
          masterTimelinesForCarouselWithVerticalLinks[key].add(slideOutCarouselImage(activeSlide));
          
          // Set active on the last clicked link
          jQuery(this).addClass('active').siblings().removeClass('active');

          // Find the target slide to slideIn and set as active
          let targetSlide = jQuery(jQuery(this).data('slide-target'));
          targetSlide.toggleClass('active').siblings().removeClass('active');
          
          masterTimelinesForCarouselWithVerticalLinks[key].add(slideInCarouselImage(targetSlide), '-=1.75');

          masterTimelinesForCarouselWithVerticalLinks[key].play();
        }
      }
    });
  });

  jQuery('.carousel--vertical-links-mixed-content').each(function(key) {
    var componentIdName = 'carousel--with-vertical-links-mixed-content-' + key;
    var sliderIdName = 'slides--vertical-links-mixed-content-' + key;
    var sliderNavIdName = 'navigation--vertical-links-mixed-content-' + key;

    this.id = componentIdName;

    jQuery('#' + componentIdName + ' .links .link:first-child').addClass('active');
    jQuery('#' + componentIdName + ' .slides .slide:first-child').addClass('active');

    jQuery('.slides--vertical-links-mixed-content')[key].id = sliderIdName;
    jQuery('.navigation--vertical-links-mixed-content')[key].id = sliderNavIdName;

    masterTimelinesForCarouselWithVerticalLinks[key] = new TimelineMax();

    jQuery('#' + componentIdName + ' .links .link').each(function(key) {
      jQuery(this).data('slide-target', '#' + componentIdName + ' #slide-' + key);
    });

    jQuery('#' + componentIdName + ' .links .link').click(function() {
      if (!jQuery(this).hasClass('.active')) {
        if (animating == false) {        
          
          startAnimating();

          // Remember which is the originally active slide
          let activeSlide = jQuery('#' + componentIdName + ' .slide.active');     
          masterTimelinesForCarouselWithVerticalLinks[key].add(slideOutCarouselMixedContent(activeSlide));
          
          // Set active on the last clicked link
          jQuery(this).addClass('active').siblings().removeClass('active');

          // Find the target slide to slideIn and set as active
          let targetSlide = jQuery(jQuery(this).data('slide-target'));
          targetSlide.toggleClass('active').siblings().removeClass('active');
          
          masterTimelinesForCarouselWithVerticalLinks[key].add(slideInCarouselMixedContent(targetSlide), '-=1.75');

          masterTimelinesForCarouselWithVerticalLinks[key].play();
        }
      }
    });
  });
}

function initiateCarouselsWithHorizontalLinks() {
  jQuery('.carousel--with-horizontal-links').each(function(key) {
    var componentIdName = 'carousel--with-horizontal-links-' + key;
    var sliderIdName = 'slider--with-horizontal-links-' + key;
    var sliderNavIdName = 'slider-nav--with-horizontal-links-' + key;

    this.id = componentIdName;
    jQuery('.slider--with-horizontal-links')[key].id = sliderIdName;
    jQuery('.slider-nav--with-horizontal-links')[key].id = sliderNavIdName;

    var componentId = '#' + componentIdName;
    var sliderId = '#' + sliderIdName;
    var sliderNavId = '#' + sliderNavIdName;

    jQuery(sliderId).slick({
      prevArrow: jQuery(componentId + ' .slider-controls .previous'),
      nextArrow: jQuery(componentId + ' .slider-controls .next'),
      // fade: true,
    });

    jQuery(sliderNavId  + ' span').click(function(){
      jQuery(this).toggleClass('active').siblings().removeClass('active');
      jQuery(sliderId).slick('slickGoTo', jQuery(this).data('target-slide-index') );
    })

    jQuery(sliderNavId + ' span:first-child').addClass('active');
  });
}

function initiateCarouselsWithPreview() {
  jQuery('.carousel--with-preview').each(function(key) {
    var componentIdName = 'carousel--with-preview-' + key;
    var sliderIdName = 'slider--with-preview-' + key;
    var sliderNavIdName = 'slider-nav--with-preview-' + key;

    this.id = componentIdName;
    jQuery('.slider--with-preview')[key].id = sliderIdName;
    jQuery('.slider-nav--with-preview')[key].id = sliderNavIdName;

    var componentId = '#' + componentIdName;
    var sliderId = '#' + sliderIdName;
    var sliderNavId = '#' + sliderNavIdName;

    jQuery(sliderId).slick({
      prevArrow: jQuery(componentId + ' .slider-controls .previous'),
      nextArrow: jQuery(componentId + ' .slider-controls .next'),
      // fade: true,
    });

    jQuery(sliderNavId).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 1,
      focusOnSelect: false,
      draggable: false,
      arrows: false,
      // dots: true,
      // fade: true,
    });

    jQuery(sliderId).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      jQuery(sliderNavId).slick('slickGoTo', parseInt(nextSlide+1) );
    });

  });
}

 function initiateThreeColumnCarousels() {
  jQuery('.carousel--three-column').each(function(key) {
    var componentIdName = 'carousel--three-column-' + key;
    var sliderIdName = 'slider--full-width-' + key;

    this.id = componentIdName;
    jQuery('.slider--full-width')[key].id = sliderIdName;

    var componentId = '#' + componentIdName;
    var sliderId = '#' + sliderIdName;

    if (!jQuery(sliderId).hasClass('slick-initialized')) {
      jQuery(sliderId).slick({
        prevArrow: jQuery(componentId + ' .slider-controls .previous'),
        nextArrow: jQuery(componentId + ' .slider-controls .next'),
        // fade: true,
      });
    }

  });
}

function initiateSelectBoxes() {
  jQuery('.js-select').select2({
    placeholder: 'Select an option',
    theme: 'bootstrap4',
  });
}

import { TimelineMax, Power4 } from 'gsap/all';

window.openActiveCarouselItem = function(clickedColumn) { 

  let columnContainer = clickedColumn.parent();

  if (!columnContainer.hasClass('open')) {
    
    columnContainer.addClass('open');    
    clickedColumn.addClass('active');    

    var expandCarouselItemsTimeline = new TimelineMax({paused: true});

    expandCarouselItemsTimeline
      .to(columnContainer.find('.preview'), 1, {opacity: 0})
      .to(columnContainer.find('.bg-gradient'), 1, {opacity: 0})
      .to(columnContainer.find('.column:not(".active")'), 1, {opacity: 0}, '-=0.5')
      .to(columnContainer.find('.column:not(".active")'), 0.5, {'flex-grow': 0})
      .to(columnContainer.find('.column.active'), 0.5, {'flex-grow': 3, ease: Power4.easeOut})
      .to(columnContainer.find('.column.active .content'), 1, {display: 'flex', opacity: 1, visibility: 'visible'});

    expandCarouselItemsTimeline.play();    
  } 
}

window.resetCarousel = function(clickedColumn){
  
  clickedColumn.removeClass('active');
  let columnContainer = clickedColumn.parent();

  var resetCarouselTimeline = new TimelineMax({paused: true});

  resetCarouselTimeline
    .to(columnContainer.find('.column .content'), 1, {opacity: 0, display: 'none'})
    .to(columnContainer.find('.column .content'), 0, {visibility: 'hidden'})
    .to(columnContainer.find('.column'), 0.5, {'flex-grow': 1})
    .to(columnContainer.find('.column'), 0.5, {opacity: 1})
    .to(columnContainer.find('.preview'), 0.5, {opacity: 1})
    .to(columnContainer.find('.bg-gradient'), 0.5, {opacity: 1});

  resetCarouselTimeline.play();
  columnContainer.removeClass('open');
}

function bindSlickEvents() {
  jQuery('.slider').on('beforeChange', function(){
    jQuery(this).parent().addClass('sliding');
  });  

  jQuery('.slider').on('afterChange', function(){
    jQuery(this).parent().removeClass('sliding');
  });  
}

function initiatePackery() {
  var $grid = $('.bricks').imagesLoaded( function() {
  // init Packery after all images have loaded
    $grid.packery({
      itemSelector: '.grid-item',
      percentPosition: true,
    });
    jQuery('.bricks').addClass('loaded');
  });  
}

export default {
  init() {
    jQuery.fancybox.defaults.animationEffect = 'fade';
    jQuery.fancybox.defaults.loop = true;

    // JavaScript to be fired on all pages
    bindSlickEvents();
    initiatePackery();
    initiateSelectBoxes();
    initiateCarouselsWithVerticalLinks();
    initiateCarouselsWithHorizontalLinks();
    initiateCarouselsWithPreview();
    initiateThreeColumnCarousels();
  },
  finalize() {

    // initMasonry();
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js